import styles from './WarningIcon.module.scss'

export const WarningIcon = () => {
  return (
    <div className={styles.iconContainer}>
      <i className="kbase kbase-warning-alt" />
    </div>
  )
}
